var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C14.4706 0 18.5 4.02944 18.5 9C18.5 13.9706 14.4706 18 9.5 18C4.52944 18 0.5 13.9706 0.5 9C0.5 4.02944 4.52944 0 9.5 0ZM12.5581 6.05806L8 10.6161L6.44194 9.0581C6.19786 8.814 5.80214 8.814 5.55806 9.0581C5.31398 9.3021 5.31398 9.6979 5.55806 9.9419L7.5581 11.9419C7.8021 12.186 8.1979 12.186 8.4419 11.9419L13.4419 6.94194C13.686 6.69786 13.686 6.30214 13.4419 6.05806C13.1979 5.81398 12.8021 5.81398 12.5581 6.05806Z",
    fill: "#00BE8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green_checkmark.787bc1935c998270abeed8adf3dc2765.svg";
export { ForwardRef as ReactComponent };